import { render, staticRenderFns } from "./CapvitalFiles.vue?vue&type=template&id=7c8195df&"
import script from "./CapvitalFiles.vue?vue&type=script&lang=js&"
export * from "./CapvitalFiles.vue?vue&type=script&lang=js&"
import style0 from "./CapvitalFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports